<template>
    <v-datepicker
            width="100%"
            input-class="form-control"
            @input="updateValue"
            :value="value"
            :lang="lang"
            :placeholder="placeholder"
            :first-day-of-week="firstDayOfWeek"
            :format="format">
        <template slot="header">{{header}}</template>
        <template slot="calendar-icon"><i class="fa fa-calendar" aria-hidden="true"></i></template>
        <template slot="footer">{{footer}}</template>
    </v-datepicker>
</template>

<script>
    import DatePicker from 'vue2-datepicker'
    import moment from 'moment'
    import i18n from '@/locale/index'

    export default {
        name: "DatePicker",
        props: {
          placeholder:{
            type:String,
            default: 'Odaberi datum'
          },
            value: {
                default: null
            },
            header: {
                type: String,
                default: null
            },
            footer: {
                type: String,
                default: null
            }
        },
        components: {
            'v-datepicker': DatePicker
        },
        data() {
            return {
                lang: {
                    days: [ i18n.t('SUN'), i18n.t('MON'), i18n.t('TUE'),  i18n.t('WED'),  i18n.t('THU'),  i18n.t('FRI'),  i18n.t('SAT')],
                    months: [ i18n.t('JAN'), i18n.t('FEB'), i18n.t('MAR'), i18n.t('APR'), i18n.t('MAY'), i18n.t('JUN'), i18n.t('JUL'), i18n.t('AUG'), i18n.t('SEP'), i18n.t('OCT'), i18n.t('NOV'), i18n.t('DEC')],
                    pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],

                },
                // custom range shortcuts
                shortcuts: [
                    {
                        text: 'Today',
                        onClick: () => {
                            this.time3 = [new Date(), new Date()]
                        }
                    }
                ],

            }
        },
        methods: {
            updateValue(val) {
                this.$emit('input', this.reformatUpdateDate(val))
            },
            reformatUpdateDate(value) {
              if(value){
                const momentDate = new moment(value)
                return momentDate.format('YYYY-MM-DD')
              } else {
                return null
              }

            }
        },
        computed: {
            firstDayOfWeek() {
                return Number(this.$t('DATE.FIRST_DAY_OF_WEEK'))
            },
            format(){
                return this.$t('DATE.DATE_FORMAT')
            }
        }
    }
</script>

<style scoped>

</style>
